import React from 'react';
import { Tooltip, Typography } from 'antd';
import styled from '@emotion/styled';
import { ShopType } from '../../../../types/shop';

interface ColumnProps {
  record: ShopType;
}

export default React.memo((props: ColumnProps) => {
  const { record } = props;
  const options = record?.options ? JSON.parse(record.options) : null;

  return (
    <StyledProductTileContainer>
      {record.imageLink ? (
        <div className="image" style={{ backgroundImage: `url('${record.imageLink}')` }} />
      ) : (
        <div className="image" />
      )}
      <Tooltip placement="topLeft" title={record.title}>
        <Typography.Text>{options?.title}</Typography.Text>
      </Tooltip>
    </StyledProductTileContainer>
  );
});

const StyledProductTileContainer = styled.div`
  display: flex;
  align-items: center;
  padding-left: 0.5rem;
  .image {
    min-width: 3.125rem;
    height: 3.125rem;
    background-color: #eee;
    background-size: cover;
    background-position: center center;
    border: 1px solid #eee;
    margin-right: 0.5rem;
  }
  span {
    font-weight: 600;
  }
  button {
    position: absolute;
    right: 0;
  }
  text-align: left;

  .ant-typography {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    line-height: 21px;
    max-height: 48px;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
`;
